export const step1 = {
  username: "",
};

export const step2 = {
  otp: "",
  password: "",
  rePassword: "",
};
